<carousel [bottomPanelArea]="'two-dimensional-carousel-' + uid"
          [bottomPanelAreaThreshold]="0.98"
          [loop]="component.sections.length > 1"
          [navigation]="{
            nextEl: '.carousel-next-' + uid,
            prevEl: '.carousel-prev-' + uid
          }"
          [autoplay]="component.autoplay && !client.isCms ? {delay: component.delay, pauseOnMouseEnter: true} : false"
          [mousewheel]="{
            forceToAxis: true,
            thresholdDelta: 10,
            thresholdTime: 200
        }"
          [keyboard]="{
            enabled: true
        }"
          [speed]="1000"
          [effect]="component.creative ? 'creative' : 'slide'"
          [creativeEffect]="creativeEffect"
          [watchSlidesProgress]="true"
          (afterInit)="handleAfterInit($event)"
          (activeIndexChange)="handleActiveIndexChange($event)"
          (slideChangeTransitionStart)="handleSectionChangeTransitionStart()"
          (slideChangeTransitionEnd)="handleSectionChangeTransitionEnd()"
          (transitionStart)="handleTransitionStart()">
    @for (section of component.sections; track sectionIndex; let sectionIndex = $index) {
    @if (!section.hide) {
    <ng-template carouselSlide
                 let-data>
        <carousel [navigation]="{
                                nextEl: '.carousel-next-' + uid + '-' + sectionIndex,
                                prevEl: '.carousel-prev-' + uid + '-' + sectionIndex
                            }"
                  [pagination]="{
                                el: '.carousel-dots-' + uid + '-' + sectionIndex,
                                enabled: true,
                                clickable: true
                            }"
                  [direction]="'vertical'"
                  [mousewheel]="section.items?.length > 1 ? {
                                releaseOnEdges: false,
                                forceToAxis: true,
                                thresholdDelta: 10,
                                thresholdTime: 10
                            } : false"
                  [touchReleaseOnEdges]="true"
                  [keyboard]="{
                                enabled: true
                            }"
                  [speed]="1000"
                  [effect]="section.creative ? 'creative' : 'slide'"
                  [creativeEffect]="creativeItemsEffect"
                  [watchSlidesProgress]="true"
                  [twoDimensionalCarouselSection]="sectionIndex"
                  (afterInit)="handleAfterInit($event, sectionIndex)"
                  (activeIndexChange)="handleActiveIndexChange($event, sectionIndex)"
                  (slideChangeTransitionEnd)="handleItemChangeTransitionEnd()"
                  (transitionStart)="handleTransitionStart()">
            @for (item of section.items; track itemIndex; let itemIndex = $index) {
            @if (!item.hide) {
            <ng-template carouselSlide>
                <div class="fill flex flex-middle overflow-hidden"
                     [style.--tdc-bg-color]="item.bgColor || '#fff'">
                    <ng-template onInView
                                 [rootMargin]="'1000px'">
                        <!-- custom cms outlet -->
                        <icms-outlet [components]="item.components"
                                     [allowOnly]="whitelist" />
                    </ng-template>
                </div>
            </ng-template>
            }
            }
            <!-- navigation -->
            <div slot="container-end">
                <button class="pos-absolute bottom-0 z-2 p-a cursor-pointer ng-hide-animate _arrow-down"
                        [class.ng-hide]="transition || (!component.navigationBottom && client.isS)"
                        [ngClass]="section.color"
                        [ngClass]="'carousel-next-' + uid + '-' + sectionIndex"
                        aria-hidden="true"
                        [attr.aria-label]="'Following slide' | translate">
                    <i class="icon-chevron-down"
                       aria-hidden="true"></i>
                </button>
                @if (!section.bulletsTitles && section.items?.length > 1) {
                <div class="ng-hide-animate"
                     [class.ng-hide]="transition"
                     [ngClass]="'carousel-dots-' + uid + '-' + sectionIndex"></div>
                }
            </div>
        </carousel>

        <div class="pos-fixed z-5 ng-hide-animate _bullets-carousel"
             [class.ng-hide]="transition || !(section.bulletsTitles && section.items?.length > 1)"
             [class._bottom]="!component.navigationBottom">
            <carousel class="swiper-overflow-visible"
                      [direction]="'vertical'"
                      [mousewheel]="{
                                         releaseOnEdges: false,
                                         forceToAxis: true,
                                         thresholdDelta: 10,
                                         thresholdTime: 200
                                     }"
                      [speed]="1000"
                      [slidesPerView]="'auto'"
                      [centeredSlides]="!!component.navigationBottom"
                      [watchSlidesProgress]="true"
                      [slideToClickedSlide]="true"
                      [twoDimensionalCarouselBullets]="sectionIndex">
                @for (item of section.items; track itemIndex; let itemIndex = $index) {
                @if (!item.hide) {
                <ng-template class="_bullet-slide"
                             carouselSlide>
                    <button class="inline-flex flex-middle no-wrap"
                            [sizeClass]="'XL: p1, MS: p2'"
                            [class._is-dot]="!item.name || item.name?.trim() === ''">{{item.name}}</button>
                </ng-template>
                }
                }
            </carousel>
        </div>
    </ng-template>
    }
    }
    <!-- navigation -->
    @if (component.sections.length > 1 && !component.navigationBottom) {
    <div slot="container-start">
        <button class="pos-absolute top-50 left-0 z-5 flex flex-middle p-a _arrow-prev"
                [class.ng-hide]="client.isS"
                [ngClass]="'carousel-prev-' + uid"
                type="button"
                [attr.aria-label]="'Previous slide' | translate">
            <i class="icon-chevron-left"
               aria-hidden="true"></i><span class="inline-block m-l-1 s1">{{prevSectionText}}</span>
        </button>
        <button class="pos-absolute top-50 right-0 z-5 flex flex-middle p-a _arrow-next"
                [class.ng-hide]="client.isS"
                [ngClass]="'carousel-next-' + uid"
                type="button"
                [attr.aria-label]="'Next slide' | translate">
            <span class="inline-block m-r-1 s1">{{nextSectionText}}</span><i class="icon-chevron-right"
               aria-hidden="true"></i>
        </button>
    </div>
    }
</carousel>

@if (component.navigationBottom || client.isS) {
<bottom-panel [bottomPanel]="'two-dimensional-carousel-' + uid">
    <div class="pos-absolute right-0 left-0 z-5 _nav"
         [class._bottom]="component.navigationBottom"
         dragScroll
         [dragscrollFade]="false"
         [scrollIntoView]="true"
         [scrollToIndex]="currentSection">
        @for (section of component.sections; track $index) {
        @if (!section.hide) {
        <button class="inline-flex flex-middle no-wrap p1"
                [class.m-l]="$first"
                [class.m-r]="$last"
                [class._is-active]="currentSection === $index"
                [class._is-dot]="!section.name || section.name?.trim() === ''"
                (click)="goToSection($index)">{{section.name}}</button>
        }
        }
    </div>
</bottom-panel>
}